<template>
  <div id="calendar-month-min">
    <div class="month-min">
      <div class="full-width month-min-header">
        <div class="days-of-week" v-for="(day, val) in days_of_week">{{$t(day) | minDayOfWeek}}</div>
      </div>
      <div class="full-width month-min-row" v-for="week in weeks" :key="week.id">
        <div  v-for="dateOfWeek in week" :class="'days-of-month ' + (dateOfWeek.format('MM') == full_date.format('MM') ? '' : 'text-disable ') ">
          <div v-if="dateOfWeek != null" :class="'text-center selected-date ' + (dateOfWeek.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'border-radius-50per' : '') " :style="dateOfWeek.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'background: ' + todayColor + '; color: #fff;' : ''" @click="setFullDate(dateOfWeek)">{{dateOfWeek.format('D')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .month-min-header {
    display: flex;
  }
  .days-of-week {
    flex: 1;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 10px;
  }
  .month-min-row {
    display: flex;
  }
  .days-of-month {
    flex: 1;
    text-align: center;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: 600;
    cursor: pointer;
  }
  .text-disable {
    color: #c2c4c6;
  }
  .border-radius-50per {
    border-radius: 50%;
  }
  .bg-main {
    background: #0091ff;
    color: #fff !important;
  }
  .selected-date {
    padding: 5px 0px;
    max-width: 100%;
    width: 30px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
<script>
export default {
  name: 'CalendarMonthMin',
  props: {
    events: {
      type: Array,
      required: false
    },
    full_date: {
      required: false
    },
    today: {
      default: false
    },
    todayColor: {
      default: '#0091ff'
    }
  },
  data: function () {
    return {
      weeks: [],
      days_of_week: {
        '0': 'sun',
        '1': 'mon',
        '2': 'tue',
        '3': 'wed',
        '4': 'thu',
        '5': 'fri',
        '6': 'sat'
      }
    }
  },
  methods: {
    createDateByMonth () {
      let date = this.$moment(this.full_date)
      let startDayOfWeek = parseInt(date.startOf('month').format('e'))
      let dates = []
      let week = 0
      for (let i = 0; i < startDayOfWeek; i++) {
        let d = this.$moment(date.startOf('month')).subtract(6 - i, 'day')
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
      }

      for (let i = date.startOf('month').format('D'); i <= date.endOf('month').format('D'); i++) {
        let d = this.$moment(date.startOf('month')).add(i - 1, 'day')
        week = Math.floor((parseInt(d.format('D')) + startDayOfWeek - 1) / 7)
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
      }

      let endDayOfWeek = parseInt(date.endOf('month').format('e'))
      for (let i = endDayOfWeek + 1; i <= 6; i++) {
        let d = this.$moment(date.endOf('month')).add(i - endDayOfWeek, 'day')
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
      }
      return dates
    },
    setFullDate (date) {
      this.$emit('setFullDate', date)
    }
  },
  filters: {
    minDayOfWeek: function (day) {
      return day.substr(0, 3).toUpperCase()
    }
  },
  created () {
    this.weeks = this.createDateByMonth()
  },
  watch: {
    full_date: function (val) {
      this.weeks = this.createDateByMonth()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/CalendarMonthMin.vue